import { ClsItem } from 'types/clsType';
import { PublicationUpload } from 'types/uploadType';

import { uploadItemTypeCls } from 'constants/cls';

type TransformMetadataBeforeCommitArgs = {
  uploadType: string;
  metadata: unknown;
};

function transformPublicationUpload(metadata: PublicationUpload): PublicationUpload {
  return {
    ...metadata,
    cKnowledgeField: metadata.cKnowledgeFieldItem?.uref || metadata.cKnowledgeField,
    cKnowledgeFieldItem: undefined,
    cLang: metadata.cLangItem?.uref || metadata.cLang,
    cLangItem: undefined,
    cPublicationLevel: metadata.cPublicationLevelItem?.uref || metadata.cPublicationLevel,
    cPublicationLevelItem: undefined,
    cScienceBranch: metadata.cScienceBranchItem?.uref || metadata.cScienceBranch,
    cScienceBranchItem: undefined,
    cSpeciality: metadata.cSpecialityItem?.uref || metadata.cSpeciality,
    cSpecialityItem: undefined,
    cType: metadata.cTypeItem?.uref || metadata.cType,
    cTypeAuthorship: metadata.cTypeAuthorshipItem?.uref || metadata.cTypeAuthorship,
    cTypeAuthorshipItem: undefined,
    cTypeItem: undefined,
    identifiers: metadata?.identifiers?.map((id) => {
      return {
        ...id,
        cIdentSystem: id.cIdentSystem ?? id.cIdentSystemItem?.uref,
        cIdentSystemItem: undefined,
      };
    }),
  };
}

export function transformMetadataBeforeCommit({ metadata, uploadType }: TransformMetadataBeforeCommitArgs): unknown {
  let transformed = metadata;
  if (uploadType === uploadItemTypeCls.publication) {
    transformed = transformPublicationUpload(metadata as PublicationUpload);
  }
  return transformed;
}

export function transformFilterValues(params: Record<string, unknown>): Record<string, unknown> {
  const transformed: Record<string, unknown> = {};
  Object.keys(params).forEach((key) => {
    const value = transformValue(params[key]);
    if (value) transformed[key] = value;
  });
  return transformed;
}

function transformValue(param: unknown): unknown {
  let transformed = param;
  if ((param as ClsItem)?.uref) transformed = (param as ClsItem).uref;
  return transformed;
}
